import { Level } from "../model/common";

export const isValidLevel = (input: string): boolean =>
  input === "beginner" || input === "intermediate" || input === "advanced";

export const levelToNumber = (level: Level): number => {
  switch (level) {
    case "beginner":
      return 0;
    case "intermediate":
      return 1;
    case "advanced":
      return 2;
    default:
      return 0;
  }
};
